import apiClient from "@services/apiClient";
import { ATP_API_URL } from "@config/apiconfig";

export const fetchDashbaordData = async (requestParams) => {
  try {
    const url = ATP_API_URL.GET_ALL_DASHBOARD_DATA;

    const response = await apiClient.post(url, requestParams);

    if (response?.data?.status) {
      return response.data;
    }
  } catch (error) {
    console.error("Dashboard API Error:", error);
    throw error;
  }
};
